<template>
    <div>
        <busy-modal :show="loading"></busy-modal>
        <b-container fluid class="mb-3">
            <file-manager :key="fileManagerKey" :owner-id="owner.id"></file-manager>
        </b-container>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import BusyModal from '../../generic/busy-modal/busy-modal.vue';
import OwnerDocumentsFrame from '../common/owner-documents-frame.vue';

const FileManager = defineAsyncComponent(() =>
    import(
        /* webpackChunkName: "lx-vue-file-manager" */
        '../../generic/file-manager/file-manager.vue'
    )
);

export default {
    name: 'OwnerEditDocuments',
    components: {
        BusyModal,
        OwnerDocumentsFrame,
        FileManager,
    },
    props: {
        owner: Object,
    },
    computed: {
        documentsFrameUrl() {
            return `/app/owner/owner/${this.owner.id}/documents-frame/`;
        },
    },
    data() {
        return {
            loading: false,
            documentsFrameKey: 0,
            fileManagerKey: 0,
        };
    },
    methods: {
        documentsFrameLoaded() {
            this.loading = false;
        },
    },
};
</script>